import { StsBackendOperation } from '../../../sts-backend-operation';
import { buildDtcCodePatchBody, type DtcCodeUpdateBodyParams } from '../helpers';

/**
 * Delete a DTC code from a Techline case by setting its status code to 2 (deleted).
 */
export class DeleteDtcCode extends StsBackendOperation {
    /**
     * Execute the delete DTC code operation.
     *
     * @param params - the case number and DTC code to delete
     * @returns true if the deletion succeeded, false otherwise
     */
    async exec(params: DtcCodeUpdateBodyParams): Promise<boolean> {
        const { caseNumber, code } = params;
        const updateBody = buildDtcCodePatchBody(caseNumber, code, { statusCode: 2 });

        const response = await this.client.updateTechlineCaseDtcCode({ updateBody });

        return Boolean(response?.success);
    }
}
